import React, { Component } from "react";
import styled from 'styled-components';
import Slider from "react-slick";
import {GatsbyImage} from 'gatsby-plugin-image';
// import {GatsbyImage} from 'gatsby-plugin-image';
import Quote from '../../assets/quote.inline.svg';
import Arrow from '.././../assets/slider-arrow-white.inline.svg'

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const TestimonialsWrapper = styled.section`
position: relative;
width:100%;
background:var(--white);
/* padding:4rem 0 0 0; */

    @media only screen and (min-width: 1024px) {
    /* padding:8rem 0 0 0; */
    }
/* 
    &:before{
    width:100%;
    height:50%;
    content:"";
    position: absolute;
    top:0;
    left:0;
    background:var(--teal);
    } */

    .slick-slider {
        background:var(--brandColor);
        .slick-list{
        transition:0.5s all ease-in-out;
        }
    }

    .quote{
    position: absolute;
    top:-2.5rem;
    left:calc(0% + 4rem);
    z-index:10;
    width:53px;

        @media only screen and (min-width: 800px) {
            width:100px;
        }

        @media only screen and (min-width: 1024px) {
            right:calc(50% - 5rem);
            left:inherit;
        }

    }

    .slide{
    width:100%;
    display:flex !important;
    flex-wrap:wrap;

    @media only screen and (min-width: 1024px) {
    flex-wrap:nowrap;
    }

        .image-wrapper{
        /* width:30%; */
        position: relative;
        min-width:100%;
        height:100%;
        padding-bottom:100%;

            @media only screen and (min-width: 400px) {
            min-width:100%;
            min-height:100%;
            padding-bottom:60%;
            }

            @media only screen and (min-width: 700px) {
                min-width:100%;
            min-height:100%;
            padding-bottom:40%;
            }

            @media only screen and (min-width: 1024px) {    
            min-width:500px;
            min-height:500px;
            }

            .image-wrapper--inner{
            width:100%;
            height:100%;
            position: absolute;
            top:0;
            left:0;
            display:flex;
            justify-content:center;
            align-items:center;
            z-index:0;
            background:var(--black);

                .gatsby-image-wrapper{
                width:100%;
                height:100%;
                position: absolute;
                top:0;
                left:0;
                opacity:0.3;
                }

            }

            .logo-wrapper{
            width:100%;
            height:100%;
            position: absolute;
            top:0;
            left:0;
            display:flex;
            justify-content:center;
            align-items:center;
            z-index:10;

                .gatsby-image-wrapper{
                width:100%;
                height:100%;
                position: absolute;
                top:0;
                left:0;

                    img{
                    object-fit:contain !important;
                    width:100% !important;
                    height:100% !important;
                    top:0% !important;
                    left:0% !important;

                        @media only screen and (min-width: 650px) {
                        width:70% !important;
                        height:70% !important;
                        top:15% !important;
                        left:15% !important;
                        }

                        @media only screen and (min-width: 1024px) {
                        width:50% !important;
                        height:50% !important;
                        top:25% !important;
                        left:25% !important;
                        }

                    }

                }
            }

        }
        .testimonial-wrapper{
        display:flex;
        align-items:flex-start;
        justify-content:center;
        flex-direction:column;
        flex-wrap:wrap;
        position: relative;
        background:var(--brandColor);
        padding:2rem;
        width:100%;
  
        
        @media only screen and (min-width: 1024px) {
        width:70%;
        padding:4rem 2rem;
        }

            .text{
            line-height:1.25rem;
            font-size:0.8rem;
            font-style:italic;
            position: relative;
            margin-bottom:2rem;

            @media only screen and (min-width: 400px) {
                line-height:1.30rem;
             font-size:0.9rem;
            }

            @media only screen and (min-width: 700px) {
                line-height:1.4rem;
                font-size:1rem;
            }

        

                @media only screen and (min-width: 1024px) {
                margin-bottom:4rem;
                line-height:1.75rem;
                font-size:1.2rem;
                }
                
            }

            .info{
            font-family:var(--font-heading);
            font-size:1.3rem;
            text-transform:uppercase;
            letter-spacing:1px;
            position:relative;

                .name{
                color:var(--white);
                }
                
                .sep{
                margin:0 1rem;
                color:var(--white);
                }

            }
        }
    }
`

const SliderArrows = styled.div`
position:absolute;
top:2rem;
right:4rem;
z-index:25;

    .arrow{
    cursor: pointer;
    transition:0.5s all ease-in-out;

        &.inactive{
        cursor: default;
        pointer-events:none;
        opacity:0.3;
        }

    }

    .prev{
    transform:rotate(180deg);
    margin-right:2rem;
    }

`

export default class TestimonialsTest extends Component {
    state = {
        slideIndex: 0,
        updateCount: 0
      };
    render() {
        const testimonials = this.props.testimonials;
        
        return (
            <TestimonialsWrapper
            className='testimonials-wrapper'
            >
            <div className="wrapper">
                <Quote className="quote" />
                <SliderArrows>
                    <Arrow 
                        className="prev arrow"
                        onClick={e => this.slider.slickPrev()}
                    />
                    <Arrow 
                        className="next arrow"
                        onClick={e => this.slider.slickNext()}
                    />
                </SliderArrows>
                <Slider
                    ref={slider => (this.slider = slider)}
                    dots={false}
                    infinite={true}
                    fade={true}
                    speed={500}
                    arrows={false}
                    slidesToShow={1}
                    autoplay={false}
                    adaptiveHeight={true}
                    slidesToScroll={1}
                >
                {
                    testimonials.map((item, index) => {      
                        
                        return(      
                            <div key={item.name + index} className="slide">
                                <div className="image-wrapper">
                                    <div className="logo-wrapper">
                                        <GatsbyImage image={item?.logo?.localFile?.childImageSharp.gatsbyImageData} />
                                    </div>
                                    <div className="image-wrapper--inner">
                                        <GatsbyImage className="background" image={item?.image?.localFile.childImageSharp.gatsbyImageData} />
                                    </div>
                                </div>
                                <div className="testimonial-wrapper">
                                    <div className="text">{item.testimony}</div>
                                    <div className="info">
                                        <span className="name">{item.name}</span> 
                                        <span className="sep">|</span>
                                        <span className="company">{item.company}</span>
                                    </div>
                                </div> 
                            </div>
                        )      
                    })
                }
                </Slider>
            </div>
        </TestimonialsWrapper>
        )
    }
}


